import { render, staticRenderFns } from "./topsports.vue?vue&type=template&id=3495360e&scoped=true&"
var script = {}
import style0 from "./topsports.vue?vue&type=style&index=0&id=3495360e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3495360e",
  null
  
)

export default component.exports